module.exports = __webpack_public_path__ + "img/logo_flypay.9fe0806f.png";